<template>
  <table class="cumulative-hit-percentages table">
    <thead>
      <tr>
        <th></th>
        <th>
          <span v-if="moreThanTwoPlayers">All opponents miss the board</span>
          <span v-else>Both opponents miss the board</span>
        </th>
        <th>One opponent hits</th>
        <th>
          <span v-if="moreThanTwoPlayers">Two or more opponents hit</span>
          <span v-else>Both opponents hit</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="displayFlop">
        <th>Flop</th>
        <td>{{ cumulativeHitPercentages.flop.percentageOfTimeEveryoneMissesTheBoard.roundToTwoDecimalPlaces() }}%</td>
        <td>{{ cumulativeHitPercentages.flop.percentageOfTimeExactlyOnePlayerHitsTheBoard.roundToTwoDecimalPlaces() }}%</td>
        <td>{{ cumulativeHitPercentages.flop.percentageOfTimeTwoOrMorePlayersHitTheBoard.roundToTwoDecimalPlaces() }}%</td>
      </tr>
      <tr v-if="displayTurn">
        <th>Turn</th>
        <td>{{ cumulativeHitPercentages.turn.percentageOfTimeEveryoneMissesTheBoard.roundToTwoDecimalPlaces() }}%</td>
        <td>{{ cumulativeHitPercentages.turn.percentageOfTimeExactlyOnePlayerHitsTheBoard.roundToTwoDecimalPlaces() }}%</td>
        <td>{{ cumulativeHitPercentages.turn.percentageOfTimeTwoOrMorePlayersHitTheBoard.roundToTwoDecimalPlaces() }}%</td>
      </tr>
      <tr v-if="displayRiver">
        <th>River</th>
        <td>{{ cumulativeHitPercentages.river.percentageOfTimeEveryoneMissesTheBoard.roundToTwoDecimalPlaces() }}%</td>
        <td>{{ cumulativeHitPercentages.river.percentageOfTimeExactlyOnePlayerHitsTheBoard.roundToTwoDecimalPlaces() }}%</td>
        <td>{{ cumulativeHitPercentages.river.percentageOfTimeTwoOrMorePlayersHitTheBoard.roundToTwoDecimalPlaces() }}%</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import utilities from '@/services/utilities/utilities';

export default {
  name: 'cumulative-hit-percentages',
  props: ['cumulativeHitPercentages', 'moreThanTwoPlayers', 'streetsToDisplay'],
  computed: {
    displayFlop: function () {
      return this.streetsToDisplay.includes('flop');
    },
    displayTurn: function () {
      return this.streetsToDisplay.includes('turn');
    },
    displayRiver: function () {
      return this.streetsToDisplay.includes('river');
    },
  },
};
</script>

<style lang="scss" scoped>
  .cumulative-hit-percentages {
    max-width: 700px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cumulative-hit-percentages.vue